import React, { memo, useState, useEffect } from 'react'
import { AddNewUser } from 'components/organisms/AddNewUser'
import AdminAutosuggest from 'apps/marketplace/components/AdminAutosuggest'
import { IDispatcher, IUser } from 'apps/marketplace/store/contractLanes/types'
import { INameSearchResult, SEARCH_TYPE } from 'apps/marketplace/utils/api/search'
import { ChangeRateData } from 'apps/marketplace/utils/helpers/useCarrier'

interface IDispatcherProps {
  dispatcher: number
  dispatcherName: string
  dispatcherList?: IDispatcher[]
  carrierApplicationId: number
  displayUserCreation?: boolean
  user?: IUser
  onChange: (arg: Partial<ChangeRateData>) => void
}

export const Dispatcher = memo<IDispatcherProps>(
  ({ carrierApplicationId, dispatcher, dispatcherName, displayUserCreation, onChange, user }) => {
    const [dispatcherUser, setDispatcherUser] = useState<Partial<INameSearchResult> | undefined>()

    // If the dispatcher has changed, change the state of the dispatcher user object.
    useEffect(() => {
      if (dispatcher && dispatcherName) {
        setDispatcherUser({
          id: `${dispatcher}`,
          name: dispatcherName,
        })
      }
    }, [dispatcher, dispatcherName])

    const setDispatcher = (selectedDispatcher?: Partial<INameSearchResult>) => {
      setDispatcherUser(selectedDispatcher)
      const { id, name } = selectedDispatcher || {}
      onChange({ dispatcher: id, dispatcherName: name })
    }

    const createNewUser = () => {
      onChange({ displayUserCreation: true, dispatcher: '', dispatcherName: '' })
    }

    const selectExistingUser = () => {
      onChange({ displayUserCreation: false })
    }

    const handleUserChange = ({ target }: React.ChangeEvent<HTMLInputElement>) => {
      onChange({ user: { ...user, [target.id]: target.value } })
    }

    const { cellPhone, email, firstName, lastName, phone, role, userType } = user || {}

    return (
      <>
        <h3>Dispatcher</h3>
        {!displayUserCreation && (
          <div className='row'>
            <div className='col-xs-4'>
              <div data-test='add-dispatcher'>
                <AdminAutosuggest
                  id='dispatcher-owner-op-user'
                  placeholder='Select a Dispatcher'
                  value={dispatcherUser}
                  onChange={setDispatcher}
                  carrierApplicationId={carrierApplicationId}
                  useParentId={false}
                  searchType={SEARCH_TYPE.CarrierUsers}
                />
              </div>
            </div>
          </div>
        )}
        <div className='row collapse'>
          <div className='col-xs-4'>
            {displayUserCreation ? (
              <button
                className='btn-text-link'
                onClick={selectExistingUser}
                data-test='existing-user'>
                Select an existing user
              </button>
            ) : (
              <button className='btn-text-link' onClick={createNewUser} data-test='new-user'>
                Or create a new user
              </button>
            )}
          </div>
        </div>
        {displayUserCreation && (
          <div className='row collapse'>
            <div className='col-xs-8'>
              <AddNewUser /*
                // @ts-ignore */
                userType={userType}
                role={role}
                firstName={firstName}
                lastName={lastName}
                email={email}
                phone={phone}
                cellPhone={cellPhone}
                handleUserChange={handleUserChange}
              />
            </div>
          </div>
        )}
      </>
    )
  }
)
